import AXIOS from "./axios";

export class Doctor {
  static all(params) {
    const queryParmas = params
      ? "?" + new URLSearchParams(params).toString()
      : "";
    return AXIOS.get(`users/doctors${queryParmas}`);
  }

  static details(id) {
    return AXIOS.get(`/doctors/${id}`);
  }

  static update(doctor_property) {
    let payload = { ...doctor_property };

    if (payload.price_cents && typeof payload.price_cents === "string") {
      let price = payload.price_cents.replace("R$ ", "").replace(",", ".");
      payload.price_cents = Math.round(Number(price) * 100);
    }

    return AXIOS.put(`doctor_properties/${payload.id}`, {
      doctor_property: payload
    });
  }

  static createConditionEntry(doctorPropertyId, name) {
    return AXIOS.post(
      `doctor_properties/${doctorPropertyId}/condition_entries`,
      { condition_entry: { name } }
    );
  }

  static deleteConditionEntry(doctorPropertyId, id) {
    return AXIOS.delete(
      `doctor_properties/${doctorPropertyId}/condition_entries/${id}`
    );
  }

  static createFormationEntry(doctorPropertyId, formation_entry) {
    return AXIOS.post(
      `doctor_properties/${doctorPropertyId}/formation_entries`,
      { formation_entry }
    );
  }

  static updateFormationEntry(doctorPropertyId, id, formation_entry) {
    return AXIOS.put(
      `doctor_properties/${doctorPropertyId}/formation_entries/${id}`,
      { formation_entry }
    );
  }

  static deleteFormationEntry(doctorPropertyId, id) {
    return AXIOS.delete(
      `doctor_properties/${doctorPropertyId}/formation_entries/${id}`
    );
  }

  static availables({ id, query }) {
    return AXIOS.get(
      `slots/doctors/${id}/availables${query ? "?" + query : ""}`
    );
  }

  static appointments() {
    return AXIOS.get("admin/doctors/appointments");
  }

  static balanceDetails() {
    return AXIOS.get("gateway_payments/balances");
  }

  static earnings() {
    return AXIOS.get("gateway_payments/earnings");
  }

  static refreshToken() {
    return AXIOS.get("gateway_medical_prescriptions/doctors/tokens/refresh");
  }

  static getCoupons(id) {
    return AXIOS.get(`coupons?doctor_id=${id}`);
  }

  static institutionDoctors({ medicalSpecialty, unitId }) {
    return AXIOS.get(
      `users/doctors?medical_specialty=${medicalSpecialty}&unit_id=${unitId}`
    );
  }

  static sendSMStoDoctor(id) {
    return AXIOS.post("doctors/notify", { doctor_notify: { doctor_id: id } });
  }

  static getDoctorCategories() {
    return AXIOS.get("doctor_categories");
  }

  static auditLog() {
    return AXIOS.get("admin/doctors/audit_log");
  }
}
